const en = {
  translation: {
    yes: "YES",
    no: "NO",
    loading: "Loading",
    email: "Email",
    password: "Password",
    "select-all": "Select all",
    clear: "Clear",
    "clear-filter": "Clear filter",
    "clear-all-filters": "Clear all filters",
    confirm: "Confirm",
    cancel: "Cancel",
    from: "From",
    to: "To",
    "date.placeholder": "dd.mm.yyyy",
    save: "Save",
    add: "Add",
    apply: "Apply",
    "reset-all": "Reset All",
    insert_value: "insert value",
    revert: "Revert",
    delete: "Delete",
    actions: "Actions",
    history: "Archive",
    "h304.warning": "Warning H304 found! Please check the kinematic viscosity",
    "hazard.warning":
      "Warning H304 found! Please check the kinematic viscosity",

    "theme.set-dark": "Set dark mode",
    "theme.set-light": "Set light mode",

    "language.tooltip": "Set language",

    "auth.login.button": "Sign In",
    "auth.logout.button": "Logout",
    "auth.login.error": "Can't login. Please try later",
    "auth.login.wrongEmail": "Wrong email",
    "auth.login.invalidCredentials": "Invalid credentials",
    "auth.validation.email.invalid": "This email is not valid!",
    "auth.validation.email.required": "Email is required!",
    "auth.validation.password.required": "Password is required!",
    "auth.validation.password.tooShort":
      "Password must be at least 8 characters",
    "auth.validation.password.requirements":
      "Password must contain at least one uppercase letter, one lowercase letter, one number and one special character",
    "auth.validation.password.match": "Passwords must match",
    "auth.validation.password.confirmRequired": "Please confirm your password",
    "auth.login.title": "Automated SDS Intelligence",
    "auth.login.slogan": "AI SDS Data Automation",
    "auth.login.subtitle": "Enter your account details",
    "auth.login.scanning": "Scanning documents...",
    "auth.login.dataExtracted": "Data successfully extracted",
    "auth.login.noAccount": "Don't have an account yet?",
    "auth.login.signUp": "Sign Up",
    "auth.acceptInvite.title": "Welcome to HSE Genius",
    "auth.acceptInvite.subtitle":
      "Please create a password to activate your account",
    "auth.acceptInvite.password": "Create Password",
    "auth.acceptInvite.confirmPassword": "Confirm Password",
    "auth.acceptInvite.submit": "Activate Account",
    "auth.acceptInvite.success":
      "Your account has been activated successfully! You will be redirected to the login page.",
    "auth.acceptInvite.error":
      "There was an error activating your account. Please try again or contact support.",
    "auth.acceptInvite.missingParams":
      "Invalid invitation link. Please check your email and try again.",
    "auth.acceptInvite.missingToken":
      "Invalid token. Please check your email and try again.",

    "auth.signup.firstName": "First name",
    "auth.signup.lastName": "Last name",
    "auth.signup.emailLabel": "Work email",
    "auth.signup.emailHint": "Use your company email (e.g. name@yourcompany.com)",
    "auth.signup.passwordLabel": "Password",
    "auth.signup.req.len": "8+ characters",
    "auth.signup.req.upper": "Uppercase",
    "auth.signup.req.digit": "Number",
    "auth.signup.req.special": "Special character",
    "auth.signup.termsPrefix": "I accept the",
    "auth.signup.termsLink": "Terms and Conditions",
    "auth.signup.termsAnd": "and the",
    "auth.signup.privacyLink": "Privacy Policy",
    "auth.signup.firstNameRequired": "Please enter your first name",
    "auth.signup.firstNameMax": "Maximum 50 characters",
    "auth.signup.lastNameRequired": "Please enter your last name",
    "auth.signup.lastNameMax": "Maximum 50 characters",
    "auth.signup.phoneInvalid": "Digits, spaces and hyphens only (use the dropdown on the left for the country code)",
    "auth.signup.phoneMax": "Maximum 10 digits",
    "auth.signup.emailInvalid": "Please enter a valid email address",
    "auth.signup.emailRequired": "Please enter your email",
    "auth.signup.passwordMin": "Minimum 8 characters",
    "auth.signup.passwordUppercase": "Add an uppercase letter",
    "auth.signup.passwordDigit": "Add a number",
    "auth.signup.passwordSpecial": "Add a special character (e.g. !@#$%)",
    "auth.signup.passwordRequired": "Choose a password",
    "auth.signup.accountCreated": "Great! Check your email for the activation code.",
    "auth.signup.errorGeneric": "Connection issue. Please try again in a moment.",
    "auth.signup.title": "Start free — 50 credits",
    "auth.signup.activateTitle": "Activate your account",
    "auth.signup.welcome":
      "Register your company and receive 50 credits instantly to try HSE Genius.",
    "auth.signup.phone": "Phone (optional)",
    "auth.signup.submit": "Create free account",
    "auth.signup.submitting": "Creating account...",
    "auth.signup.emailNotice": "You'll receive a 6-digit verification code by email to activate your account.",
    "auth.signup.hasAccount": "Already have an account?",
    "auth.signup.signIn": "Sign In",
    "auth.signup.typeCompany": "Company",
    "auth.signup.typeConsultant": "HSE Consultant",
    "auth.signup.emailLabelConsultant": "Email",
    "auth.signup.emailHintConsultant": "Use your personal or professional email",
    "auth.signup.phoneRequired": "Phone *",
    "auth.signup.phoneRequiredError": "Please enter your phone number",
    "auth.signup.partitaIva": "VAT Number (optional)",
    "auth.signup.pendingTitle": "Email verified!",
    "auth.signup.pendingMessage": "Your consultant account is being reviewed by the HSE Genius team. You will receive an email as soon as it is activated — usually within 24h.",
    "auth.signup.goToLogin": "Go to Login",
    "auth.signup.activatedTitle": "Account activated!",
    "auth.signup.activatedMessage": "Signing you in...",
    "auth.signup.otpTitle": "Almost there!",
    "auth.signup.otpMessage": "Enter the 6-digit code we sent to your email.",
    "auth.signup.activating": "Activating...",
    "auth.signup.activateBtn": "Activate account",
    "auth.signup.resendCode": "Send a new code",
    "auth.signup.backToSignup": "Back to registration",
    "auth.signup.checkEmail": "Check your email for activation instructions.",
    "auth.signup.loginAfterActivation": "Activation complete! Sign in to continue.",
    "auth.signup.activationError": "Check the code and try again.",
    "auth.signup.resendDialog.title": "Send a new code",
    "auth.signup.resendDialog.message": "We'll send a new activation code to",
    "auth.signup.resendDialog.sending": "Sending...",
    "auth.signup.resendDialog.confirm": "Send",
    "auth.signup.trust1": "✓ No credit card required",
    "auth.signup.trust2": "✓ Active in 2 minutes",
    "auth.signup.trust3": "✓ 50 free credits",
    "auth.signup.resendActivation": "Resend Activation Email",
    "auth.common.6digits":
      "Please enter the 6-digit code we sent to your email.",
    "auth.common.resendCode": "Resend code",
    "auth.common.signInBack": "Back to sign in",
    "auth.common.verifyCode": "Verify code",

    "auth.resetPassword.title": "Reset Password",
    "auth.resetPassword.subtitle":
      "Enter your email address and we'll send you a reset code",
    "auth.resetPassword.emailSent":
      "If an account with that email exists, a reset email has been sent",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm Password",
    "auth.resetPassword.token": "Reset Token",
    "auth.resetPassword.success":
      "Password reset successfully! Redirecting to login...",
    "auth.login.forgotPassword": "Forgot password?",
    "auth.resetPassword.support":
      "If you are experiencing an error, send us an email to",
    "auth.resetPassword.supportLink": "our support",
    "auth.mfa.title": "Two-Factor Authentication",
    "auth.mfa.subtitle": "Open your authenticator app (Google Authenticator, Authy, etc.) and enter the 6-digit code for HSE Genius.",
    "auth.mfa.codeLabel": "6-digit code",
    "auth.mfa.verify": "Verify",
    "auth.mfa.error.sessionExpired": "Your MFA verification session expired. Please log in again.",
    "auth.mfa.error.codeLength": "Enter the 6-digit code from your authenticator app.",
    "auth.mfa.error.invalidCode": "Invalid code. Please try again.",
    "welcome.greeting": "Hi, {{name}}!",
    "welcome.today": "Today is",
    "welcome.stat.imported": "SDS imported",
    "welcome.stat.validated": "SDS validated",
    "welcome.stat.archive": "Archive",
    "welcome.enter": "Let's go",
    "profile.edit.button": "Edit Profile",
    "profile.title": "Profile",
    "profile.first-name.required": "First name is required",
    "profile.last-name.required": "Last name is required",
    "profile.phone.required": "Phone is required",
    "profile.email.invalid-format": "Invalid email format",
    "profile.email.required": "Email is required",
    "profile.password.required": "Password is required",
    "profile.password-mismatch": "Passwords don't match",

    "first-name": "First Name",
    "last-name": "Last Name",
    "phone-number": "Phone Number",
    "password-confirm": "Confirm Password",
    "edit-profile.title": "Edit Profile",
    "edit-profile.change-password": "Change Password",
    "edit-profile.success": "Profile updated successfully",

    "uploading-files.title": "Upload",
    "uploading-files.upload.error":
      "An error occurred while uploading the file!",
    "uploading-files.dropzone.text.1": "Import ",
    "uploading-files.dropzone.text.2": "Safety Data Sheets",
    "uploading-files.dropzone.text.3": " to upload",
    "uploading-files.dropzone.text.active": "Drop here",
    "uploading-files.uploaded-files": "SDS to process",
    "uploading-files.sds-to-import": "SDS to import",
    "uploading-files.uploading-pdf": "Uploading PDF...",
    "uploading-files.imported-count": "New imported sheets",
    "upload-files.get.error": "Error loading uploaded files",
    "upload-files.delete.error": "Error deleting uploaded file",
    "upload-files.confirm": "Process",
    "upload-files.confirm.error": "Error confirming uploaded files",
    "ai-processing.scanning": "Scanning PDF...",
    "ai-processing.extracting": "Extracting data...",
    "ai-processing.structuring": "Structuring information...",
    "ai-processing.organizing": "Organizing table...",

    "parsed-files.title": "Imported",
    "parsed-files.proceed": "Finalize",
    "parsed-files.proceed.success.popup":
      "Thank you for using HSE Genius!\nYour operation has been completed successfully.\nA summary has been sent via email.",
    "parsed-files.send-email.button": "Send email report",
    "parsed-files.send-email.success": "Email sent successfully",
    "parsed-files.send-email.error":
      "An error occurred while sending an email!",
    "parsed-files.export": "Export",
    "parsed-files.export.success": "Data exported successfully",
    "parsed-files.export.error": "An error occurred while exporting the data!",
    "parsed-files.update.error":
      "An error occurred while editing the file data!",
    "parsed-files.get.error": "An error occurred while loading data!",
    "parsed-files.invalid-concentration":
      "Invalid concentration: correct the highlighted cells and try again.",
    "parsed-files.proceed.success": "Data proceed successfully",
    "parsed-files.proceed.error":
      "An error occurred while proceeding the data!",
    "parsed-files.create.title": "Add new record",
    "parsed-files.create.error": "An error occurred while creating the record!",
    "parsed-files.delete.error": "An error occurred while deleting the record!",
    "parsed-files.disabling": "Disabling",
    "parsed-files.validating": "Validating",
    "parsed-files.valid.title": "Validate",
    "parsed-files.fullscreen": "Full screen",
    "parsed-files.fullscreen-exit": "Exit full screen",
    "parsed-files.fullscreen-menu": "Menu",
    "parsed-files.history.customer-not-found": "Customer not found",
    "parsed-files.history.customer-not-found-description":
      "Please create a new customer or select an existing one.",
    "parsed-files.history.customer-not-found-error":
      "Customer not found. Please create a new customer or select an existing one.",
    "parsed-files.history.search-customer": "Search customer",
    "parsed-files.history.not-assigned": "Not assigned",
    "parsed-files.history.search-by-name-or-vat": "Search by name or VAT",
    "parsed-files.history.duplicate-to-parsed": "Duplicate to Imported",
    "parsed-files.history.move-to-parsed": "Move to Imported",
    "parsed-files.history.duplicate-success": "Record duplicated to Imported.",
    "parsed-files.history.move-success": "Record(s) moved to Imported.",

    "parsed-table.eer_codes": "eer codes",
    "parsed-table.nome_file": "file name",
    "parsed-table.ghs": "GHS",
    "parsed-table.numero_onu": "UN number",
    "parsed-table.classe": "class",
    "parsed-table.data_di_revisione": "revision date",
    "parsed-table.gruppo_di_imballaggio": "packing group",
    "parsed-table.h_punto_2": "H 2.1 and EUH 2",
    "parsed-table.precautionary_statements": "P statements",
    "parsed-table.h_punto_3": "H/EUH 3",
    "parsed-table.h_echa_harmonized_classification":
      "H ECHA Harmonized Classification",
    "parsed-table.nome_del_prodotto": "product name",
    "parsed-table.cod_art": "art. code",
    "parsed-table.produttore": "manufacturer",
    "parsed-table.zdhc": "Zdhc",
    "parsed-table.pericoloso_per_lambiente": "environmental hazard",
    "parsed-table.stato_fisico": "state of matter",
    "parsed-table.uso_appropriato": "appropriate use",
    "parsed-table.actions": "actions",
    "parsed-table.collapse-all-rows": "Collapse all rows",
    "parsed-table.expand-all-rows": "Expand all rows",
    "parsed-table.cas": "CAS/EC/REACH",
    "parsed-table.composizione_punto_3": "composition point 3",
    "parsed-table.concentrazione": "concentration",
    "parsed-table.concentration": "% SDS of the EER code",
    "parsed-table.user_concentration": "% SDS of the EER code",
    "parsed-table.svch": "SVHC",
    "parsed-table.allegato_xiv": "Annex XIV",
    "parsed-table.qty_seveso": "Q.ty Seveso",
    "parsed-table.seveso": "Seveso",
    "parsed-table.seveso_code_h2": "L. Seveso H2",
    "parsed-table.seveso_code_p15": "L. Seveso P15",
    "parsed-table.seveso_match": "Seveso Match",
    "parsed-table.punto_di_ebollizione": "boiling point",
    "parsed-table.ph": "ph",
    "parsed-table.cov": "cov",
    "parsed-table.notes": "notes",
    "parsed-table.sds_8_2_info": "8.2. Exposure controls",
    "parsed-table.sds_8_2_view_details": "View details",
    "parsed-table.sds_8_2_technical_controls": "8.2 Exposure controls",
    "parsed-table.sds_8_2_ppe_hands": "PPE Hands (material / breakthrough)",
    "parsed-table.sds_8_2_ppe_skin": "PPE Skin",
    "parsed-table.sds_8_2_ppe_body": "PPE Body",
    "parsed-table.sds_8_2_ppe_hands_skin_body": "PPE Hands, skin & body (paragraphs: hands, then skin, then body)",
    "parsed-table.sds_8_2_ppe_eyes": "PPE Eyes",
    "parsed-table.sds_8_2_ppe_respiratory": "PPE Respiratory",
    "parsed-table.sds_8_2_hygiene_other": "Hygiene / other notes",
    "parsed-table.sds_8_2_ppe_environmental_exposure": "Environmental exposure controls",
    "parsed-table.sds_8_2_ppe_complementary_emergency_measures": "Complementary emergency measures",
    "parsed-table.sds_8_2_ppe_thermal_risk": "Thermal risk",
    "parsed-table.status": "status",
    "parsed-table.status_changed_at": "status changed at",
    "parsed-table.history.noChanges": "No modifications",
    "parsed-table.history.modifications": "Modifications",
    "parsed-table.history.before": "Before",
    "parsed-table.history.after": "After",
    "parsed-table.history.user": "User",
    "parsed-table.history.datetime": "Date/Time",
    "parsed-table.history.show-icon": "Show history icon",
    "parsed-table.username": "Username",
    "parsed-table.created_at": "Import Date",
    "parsed-table.customer": "customer",

    "parsed-table.sub_total_mixture": "Sub Total Mixture",
    "parsed-table.sub_total_aggregation": "Sub Total Aggregation",
    "parsed-table.total_mixture": "Total Mixture",
    "parsed-table.total_aggregation": "Total Aggregation",
    "parsed-table.sub_total": "Sub Total",
    "parsed-table.total": "Total",

    "files-history.title": "Archive",
    "files-history.empty-table": "Files archive is empty",
    "files-history.totals": "{{count}} SDS",

    "eer-codes.label": "Select EER Codes",
    "eer-codes.get.error": "An error occurred while loading EER codes!",
    "eer-codes.filter": "EER code",
    "eer-codes.filter-singular": "EER code",
    "eercode.update.success": "EER code updated successfully",
    "eercode.update.error": "Error updating EER code",
    "eercode.remove.success": "EER code removed successfully",
    "eercode.remove.error": "Error removing EER code",

    "column-manager.title": "Manage columns",
    "column-manager.hint": "Drag to reorder, check to show column",
    "column-manager.reset": "Reset to default",

    "p-statements-catalog.title": "P statements reference",
    "p-statements-catalog.search-placeholder": "Search by P code",
    "p-statements-catalog.export-csv": "Export CSV",
    "p-statements-catalog.export-filename": "p-statements.csv",
    "p-statements-catalog.code": "Code",
    "p-statements-catalog.description": "Description",
    "p-statements-catalog.empty": "No matching P codes.",
    "p-statements-catalog.info-tooltip": "View full P statements catalog",
    "p-statements-catalog.close": "Close",

    "not-found.title": "Page Not Found",
    "not-found.subtitle": "The page you are looking for does not exist.",

    "sub-rows.title": "Add sub-row",
    "sub-rows.field-required": "This field is required",
    "sub-rows.create.error": "Error creating sub-row",

    "table-preferences.title": "Table Preferences",
    "table-preferences.light-mode": "Light mode",
    "table-preferences.dark-mode": "Dark mode",
    "table-preferences.even-color": "Even rows color",
    "table-preferences.odd-color": "Odd rows color",
    "table-preferences.selected-color": "Selected rows color",
    "table-preferences.text-color": "Text color",

    "parsed-files-validation.title": "Validation",
    "parsed-files.validate": "HP Finder",
    "parsed-files.validate.confirmation":
      "Do you want to add the records to the existing EER code on the validation page?",
    "parsed-files.validate.eer-required":
      "Please insert an EER code for all rows before using HP Finder. Rows without EER code cannot be validated.",

    "parsed-files.export.no-id":
      "You haven't selected any records. Do you want export all records?",
    "parsed-files.proceed.no-id":
      "You haven't selected any records. Do you want proceed all records?",
    "parsed-files.validate.no-id":
      "You haven't selected any records. Do you want validate all records?",
    "parsed-files.revert.no-id":
      "You haven't selected any records. Do you want revert all records?",
    "parsed-files.revert.error": "Error reverting files",
    "parsed-files.validate.success": "Records validated.",
    "parsed-files.revert.success": "Records reverted to parsed.",

    "footer.note":
      "HSE GENIUS® may make mistakes. Consider verifying important information.",
    "footer.instructions": "Instructions",

    "config.title": "Watchlist",
    "config.info": "Words in the watchlist are used when parsing SDS: every occurrence inside the «Composition point 3» column is marked and shown in red in the parsed files table. Add the terms you want to highlight (e.g. substance names, hazard codes); they are matched case-insensitively.",
    "config.word": "Word",
    "config.addButton": "Add new",
    "config.dialog.title": "Add new",
    "config.fetch.error": "Error fetching configuration",
    "config.add.error": "Error adding configuration",
    "config.remove.error": "Error removing configuration",

    "customers.title": "Customers",
    "customers.export": "Export",
    "customers.create": "Add customer",
    "customers.createCustomer": "Create new customer",
    "customers.createCustomerDescription":
      "Enter the details of the new customer",
    "customers.fields.name": "Name",
    "customers.fields.slag": "Abbreviation",
    "customers.fields.email": "Email",
    "customers.fields.phone": "Phone",
    "customers.fields.address": "Address",
    "customers.fields.city": "City",
    "customers.fields.postalCode": "Postal Code",
    "customers.fields.country": "Country",
    "customers.fields.vat": "VAT Number",
    "customers.errors.nameRequired": "Name is required",
    "customers.errors.slagRequired": "Abbreviation is required",
    "customers.errors.emailRequired": "Email is required",
    "customers.errors.emailInvalid": "Email is invalid",
    "customers.errors.cityRequired": "City is required",
    "customers.errors.postalCodeRequired": "Postal code is required",
    "customers.errors.countryRequired": "Country is required",
    "customers.errors.vatRequired": "VAT number is required",
    "customers.notifications.createSuccess": "Customer created successfully",
    "customers.notifications.createError": "Error creating customer",
    "customers.notifications.updateSuccess": "Customer updated successfully",
    "customers.notifications.updateError": "Error updating customer",
    "customers.edit.success": "Customer edited successfully",
    "customers.edit.error": "Error editing customer",
    "customers.delete.confirmation":
      "Are you sure you want to delete {{count}} customer(s)?",
    "customers.delete.success": "Customer(s) deleted successfully",
    "customers.delete.error": "Error deleting customer(s)",
    "customers.fetch.error": "Error fetching customers",
    "customers.noCustomers": "No customers found",

    "parsed-files": {
      history: {
        title: "Save to Archive",
        description: "Select a customer to save the selected items to archive.",
        "selected-description":
          "Do you want to save {{count}} selected rows to archive?",
        "all-description": "Do you want to save all rows to archive?",
        step1: "Select Customer",
        step2: "Confirm",
        "select-customer": "Select a customer",
        confirm: "Are you sure you want to save these items to archive?",
        save: "Save to Archive",
        success: "Items saved to archive successfully",
        error: "Error saving items to archive",
        "no-customer": "Please select a customer",
        "remove-from-parsed-after": "Remove SDS from Imported page after save",
        notes: "Notes",
        "enter-notes": "Enter notes (optional)",
      },
    },

    // Company page translations
    "admin.tabs.company": "Company Management",
    "admin.tabs.subscription": "Subscription Management",
    "admin.tabs.companyUsers": "Company Users",
    "admin.tabs.invites": "User Invites",
    "admin.tabs.logs": "Logs",

    // Company section
    "admin.company.title": "Company Details",
    "admin.company.vatNumber": "VAT Number",
    "admin.company.vatLabel": "VAT",
    "admin.company.companyName": "Company Name",
    "admin.company.companyEmail": "Company Email",
    "admin.company.phoneNumber": "Phone Number",
    "admin.company.city": "City",
    "admin.company.country": "Country",
    "admin.company.address": "Address",
    "admin.company.postalCode": "Postal Code",
    "admin.company.submit": "CREATE",
    "admin.company.publicEmailError":
      "Please use your company email. Public email domains are not allowed.",
    "admin.company.createSuccess": "Company created successfully!",
    "admin.company.sdiUniqueCode": "SDI Unique Code",
    "admin.company.sdiUniqueCodeRequired": "SDI Unique Code is required.",
    "admin.company.countryCode": "Country Code",
    "admin.company.countryCodeRequired": "Country code is required.",
    "admin.company.companyUsers": "Company Users",
    "admin.company.contactInfo": "Contact Information",
    "admin.company.additionalInfo": "Additional Information",
    "admin.company.usersFetchError": "Failed to load company users",
    "admin.company.member": "Member",
    "admin.company.noUsers": "No users found for this company",
    "admin.company.userName": "User Name",
    "admin.company.active": "Active",
    "admin.company.waiting": "Waiting",
    "admin.company.role": "Role",
    "admin.company.actions": "Actions",
    "admin.company.edit": "Edit",
    "admin.company.delete": "Delete",
    "admin.company.editRole": "Edit User Role",
    "admin.company.confirmDelete": "Are you sure you want to delete this user?",
    "admin.company.updateError": "Error updating user role. Please try again.",
    "admin.company.deleteError": "Error deleting user. Please try again.",
    "admin.company.employee": "Employee",
    "admin.company.requestCount": "Total SDS Processed",
    "admin.company.requestLimit": "Total SDS of the subscription per month",
    "admin.company.creditLimit": "Total remain SDS credits",
    "admin.company.createdAt": "License valid from",
    "admin.company.expiredAt": "License Expiration Date",
    "admin.company.resendInviteSuccess": "Invitation resent successfully",
    "admin.company.premiumService": "Premium Service",
    "admin.company.premiumAudit": "Audit",
    "admin.company.premiumAuditHint": "Enable the Audit page for your company. Premium feature.",
    "admin.company.premiumAuditUpdated": "Audit service updated.",
    "admin.company.premiumAuditUpdateError": "Unable to update.",
    "admin.company.premiumAuditActive": "Active",
    "admin.company.premiumAuditInactive": "Inactive",
    "admin.company.premiumAuditContactReferente": "Contact your HSE Genius contact to enable it.",
    "admin.company.mfaRequired": "Require 2FA for all company users",
    "admin.company.mfaRequiredActive": "All users must complete TOTP enrollment on next login.",
    "admin.company.createdTitle": "Company Created",
    "admin.company.created":
      "Congratulations! Your company has been successfully registered.\n\nWe've activated the Demo Package for you — you now have 50 credits to explore and test HSE Genius.\n\nStart now and discover its full potential!",

    // Subscription section
    "admin.subscription.title": "Subscription Plans",
    "admin.subscription.features.oneTime": "Credit Limit: {{count}}",
    "admin.subscription.features.sdsPerMonth": "{{count}} SDS per month",
    "admin.subscription.features.sds": "{{count}} SDS",
    "admin.subscription.features.additionalSds":
      "After {{count}} SDS, €{{price}} per additional SDS",
    "admin.subscription.features.dataArchive": "Data archive",
    "admin.subscription.features.eerHandling": "EER code handling",
    "admin.subscription.features.hpCalculator": "Extraction with HP calculator",
    "admin.subscription.features.aggregationCalculator":
      "Special function: aggregation calculator",
    "admin.subscription.features.blendCalculator":
      "Special function: blend calculator",
    "admin.subscription.features.prioritySupport": "Priority support",
    "admin.subscription.features.multiUserDashboard":
      "Multiple users dashboard",
    "admin.subscription.perMonth": "/month",
    "admin.subscription.selected": "Selected",
    "admin.subscription.select": "Select",
    "admin.subscription.quantityLabel": "Buy credit",
    "admin.subscription.activated": "Activated",
    "admin.subscription.success.title": "License Active!",
    "admin.subscription.success.content":
      "Thank you for choosing HSE Genius. Your license is now active and you can start using all available features right away.",
    "admin.subscription.checkout": "Pay",
    "admin.subscription.paymentError": "Payment error. Please try again.",
    "admin.subscription.active": "Active Subscription",
    "admin.subscription.plan": "Plan",
    "admin.subscription.status": "Status",
    "admin.subscription.paused": "Subscription is currently paused",
    "admin.subscription.created": "Created",
    "admin.subscription.nextPayment": "Next Payment",
    "admin.subscription.expires": "Expires",
    "admin.subscription.cancelAtEnd": "Auto-cancel at the end of the period",
    "admin.subscription.oneTime": "{{amount}}€/package + VAT",
    "admin.subscription.annualBilling":
      "Annual billing: {{amount}}€ + VAT per year",
    "admin.subscription.inactive": "Inactive",
    "admin.subscription.paymentRef": "Payment Reference",
    "admin.subscription.paymentMethod": {
      cc: "Credit Card",
      wire: "Wire Transfer",
      label: "Payment Method",
    },
    "admin.subscription.wireTransfer": {
      title: "Wire Transfer Details",
      firstName: "First Name",
      lastName: "Last Name",
      iban: "IBAN",
      submit: "Submit",
      required: "All fields are required.",
    },
    "admin.subscription.createOrder": "Create order",
    "admin.subscription.orderCreated":
      "Order created, verify the email for details",
    "admin.subscription.proceed": "Proceed",
    "admin.subscription.proceedToPayment": "Proceed to Payment",

    // Invites section
    "admin.invites.title": "Invite Users",
    "admin.invites.subtitle":
      "Send an invitation email to collaborate on your project",
    "admin.invites.emailAddress": "Email Address",
    "admin.invites.emailPlaceholder": "colleague@company.com",
    "admin.invites.firstName": "First Name",
    "admin.invites.lastName": "Last Name",
    "admin.invites.phone": "Phone Number",
    "admin.invites.role": "Role",
    "admin.invites.roleAdmin": "Administrator",
    "admin.invites.roleAuditor": "Auditor",
    "admin.invites.roleEmployee": "Employee",
    "admin.invites.roleViewer": "Viewer",
    "admin.invites.errorRequiredRole": "Role is required",
    "admin.invites.firstNamePlaceholder": "Enter first name",
    "admin.invites.lastNamePlaceholder": "Enter last name",
    "admin.invites.phonePlaceholder": "Enter phone number",
    "admin.invites.sending": "Sending...",
    "admin.invites.sendInvite": "Send",
    "admin.invites.pending": "Pending",
    "admin.invites.accepted": "Accepted",
    "admin.invites.expired": "Expired",
    "admin.invites.invitedUsers": "Invited Users",
    "admin.invites.resendInvite": "Resend Invite",
    "admin.invites.removeInvite": "Remove Invite",
    "admin.invites.sentSuccess": "Invitation sent successfully!",
    "admin.invites.resendSuccess": "Invitation resent to {{email}}",
    "admin.invites.removeSuccess": "Invitation removed",
    "admin.invites.invitedAt": "Invited at",
    "admin.invites.invitedOn": "Invited on",
    "admin.invites.status": "Status",
    "admin.invites.actions": "Actions",
    "admin.invites.noInvites": "No invitations sent yet",
    "admin.invites.errorRequiredEmail": "Please enter an email address",
    "admin.invites.errorValidEmail":
      "Please enter a valid company email address",
    "admin.invites.errorValidEmailFormat": "Invalid email format",
    "admin.invites.errorRequiredFirstName": "First name is required",
    "admin.invites.errorRequiredLastName": "Last name is required",
    "admin.invites.errorRequiredPhone": "Phone number is required",
    "admin.invites.errorDuplicateEmail": "This email has already been invited",
    "admin.invites.failedInvite":
      "Failed to send invitation. Please try again.",
    "admin.invites.failedResend": "Failed to resend invitation",
    "admin.invites.failedRemove": "Failed to remove invitation",

    // Logs section
    "admin.logs.title": "Logs",
    "admin.logs.subtitle": "View the logs of the company",
    "admin.logs.logs": "Logs",
    "admin.logs.noLogs": "No logs found",
    "admin.logs.logsFetchError": "Failed to load logs",
    "admin.logs.logsFetchSuccess": "Logs loaded successfully",
    "admin.logs.table.id": "ID",
    "admin.logs.table.action": "Action",
    "admin.logs.table.status": "Status",
    "admin.logs.table.documentStatus": "Document status",
    "admin.logs.table.ip": "IP",
    "admin.logs.table.timestamp": "Timestamp",
    "admin.logs.table.user": "User",
    "admin.logs.table.filename": "Filename",
    "admin.logs.export": "Export",
    "admin.logs.noLogsFiltered": "No logs match the filters",
    "admin.logs.filterAll": "All",
    "admin.logs.totals": "{{count}} SDS",
    "admin.logs.totalsFiltered": "{{count}} shown on this page ({{total}} total)",
    "admin.logs.localeSettings": "Export & locale settings",

    "audit.export": "Export",
    "audit.export.modificheStatus": "Modifiche Status",
    "audit.export.modificheOps": "Modifiche operations",
    "audit.export.modificheFilename": "Modifiche Filename",
    "audit.table.status": "Status",
    "audit.table.lastUser": "User last operation",
    "audit.table.timestampLastOp": "Date/Time last operation",
    "audit.table.filename": "Filename",
    "audit.table.revisionDate": "Revision date",
    "audit.status.created": "Created",
    "audit.status.parsing": "Parsing",
    "audit.status.validated": "Validated",
    "audit.status.history": "Archive",
    "audit.status.deleted": "Deleted",
    "audit.subtitle": "Immutable register of all operations on safety data sheets, supporting audits and in line with traceability and document control requirements.",
    "audit.premium.title": "Premium Service",
    "audit.premium.description": "The Audit service is a premium feature. Extend your subscription to enable it.",
    "audit.localeSettings": "Export & locale settings",
    "audit.downloadJson": "Download JSON",
    "audit.json.document_id": "Document ID",
    "audit.json.filename": "Filename",
    "audit.json.status": "Status",
    "audit.json.timestamp": "Timestamp",
    "audit.json.timestamp_formatted": "Date/Time formatted",
    "audit.json.user_full_name": "User full name",
    "audit.json.user_email": "User email",
    "audit.json.ip_address": "IP address",
    "audit.json.changes_per_field": "Changes per field",
    "audit.json.field": "Field",
    "audit.json.before": "Before",
    "audit.json.after": "After",
    "audit.json.changes": "Changes",

    "localeExportSettings.title": "Export and international settings",
    "localeExportSettings.csvSection": "CSV",
    "localeExportSettings.csvListSeparator": "CSV column separator",
    "localeExportSettings.dateTimeSection": "Date and time",
    "localeExportSettings.dateFormat": "Date format",
    "localeExportSettings.dateSeparator": "Date separator",
    "localeExportSettings.timeFormat": "Time format (24 or 12)",
    "localeExportSettings.timeSeparator": "Time separator",
    "localeExportSettings.numbersSection": "Numbers",
    "localeExportSettings.decimalSeparator": "Decimal separator",
    "localeExportSettings.thousandsSeparator": "Thousands separator",
    "localeExportSettings.decimalPlaces": "Decimal places",
    "localeExportSettings.loadError": "Failed to load settings",
    "localeExportSettings.saveError": "Failed to save settings",

    // UI elements
    Search: "Search",
    Confirm: "Confirm",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "support.title": "Contact Support",
    "support.description": "Need help? Send us a message and we'll respond within 24 hours.",
    "support.type.label": "Request Type",
    "support.type.help": "Help",
    "support.type.info": "Information",
    "support.type.other": "Other",
    "support.subject": "Subject",
    "support.message": "Message",
    "support.send": "Send",
    "support.request.sent": "Request sent successfully!",
    "support.response.time": "We'll respond within 24 hours.",

    // Common UI strings
    "common.copied": "Copied to clipboard",
    "common.noData": "No data found",
    "common.error.generic": "An unexpected error occurred",
    "common.errorBoundary": "Something went wrong",
    "common.error.network": "Network error. Please check your connection.",
    "common.error.server": "Server error. Please try again later.",
    "common.loading": "Loading...",
    "common.required": "This field is required",
    "common.optional": "Optional",

    // Form validation
    "validation.firstName.required": "First name is required",
    "validation.lastName.required": "Last name is required",
    "validation.phone.required": "Phone number is required",
    "validation.phone.invalid": "Invalid phone number",
    "validation.countryCode.required": "Country code is required",

    // Signup page
    "signup.title": "Sign Up",
    "signup.activateAccount": "Activate Account",
    "signup.activating": "Activating...",
    "signup.signingUp": "Signing Up...",
    "signup.accountCreated": "Account Created Successfully!",
    "signup.enterCode": "Please enter the 6-digit activation code sent to your email.",
    "signup.activationSuccess": "Account Activated Successfully!",
    "signup.loggingIn": "Logging you in automatically...",
    "signup.resendCode": "Resend Activation Code",
    "signup.backToSignup": "Go back to signup",
    "signup.alreadyHaveAccount": "Already have an account?",
    "signup.or": "OR",
    "signup.passwordHint": "Password must contain at least 8 characters, including uppercase, lowercase, number and special character.",
    "signup.acceptTerms": "I accept the",
    "signup.termsAndConditions": "Terms and Conditions",
    "signup.and": "and",
    "signup.privacyPolicy": "Privacy Policy",
    "signup.checkEmail": "Please check your email for activation instructions.",
    "signup.resendActivation": "Resend Activation Email",
    "signup.goToLogin": "Go to Login",
    "signup.resendDialog.title": "Resend Activation Code",
    "signup.resendDialog.message": "Would you like to resend the activation code to {{email}}?",
    "signup.resendDialog.sending": "Sending...",
    "signup.resendDialog.resend": "Resend",
    "signup.codeSent": "Activation code sent successfully. Please check your inbox.",
    "signup.activationError": "Failed to activate account. Please try again.",
    "signup.loginFailed": "Account was activated but login failed. Please login manually.",
    "signup.invalidCode": "Please enter a valid 6-digit activation code",

    // Analytics
    "analytics.title": "Analytics",
    "analytics.subtitle.company": "Overview of your SDS inventory — admins only",
    "analytics.subtitle.user": "Statistics for {{name}}",
    "analytics.badge.mockData": "Sample data — API connection coming soon",
    "analytics.adminOnly": "This section is reserved for company administrators.",
    "analytics.filterUser.label": "FILTER BY USER",
    "sidebar.whats_new": "What's New v5",
    "analytics.filterUser.allCompany": "All company",
    "analytics.filterUser.tooltip": "{{name}} — {{role}} · {{count}} SDS",
    "analytics.kpi.total": "SDS in Inventory",
    "analytics.kpi.validated": "Validated SDS",
    "analytics.kpi.inProgress": "In Progress",
    "analytics.kpi.svch": "SVHC Alerts",
    "analytics.kpi.thisMonth": "Added this month",
    "analytics.kpi.validated.pct": "{{pct}}% validated",
    "analytics.kpi.validated.sub": "Archived or in HP Finder",
    "analytics.kpi.inProgress.sub": "Parsing + editing",
    "analytics.kpi.svch.sub": "Substances of very high concern",
    "analytics.kpi.thisMonth.trend": "{{trend}} vs last month",
    "analytics.ghs.title": "GHS Pictograms",
    "analytics.ghs.subtitle": "Distribution by hazard class",
    "analytics.ghs.total": "total",
    "analytics.hp.title": "HP Hazard Classes",
    "analytics.hp.subtitle": "H phrases section 2 — occurrences in catalog",
    "analytics.dpi.title": "Required PPE (Sec. 8.2)",
    "analytics.dpi.subtitle": "% of SDS requiring each device",
    "analytics.clienti.title": "SDS per Customer / Site",
    "analytics.clienti.subtitle": "Inventory distribution",
    "analytics.heatmap.title": "Upload Activity — Last 12 months",
    "analytics.heatmap.jan": "jan", "analytics.heatmap.feb": "feb", "analytics.heatmap.mar": "mar",
    "analytics.heatmap.apr": "apr", "analytics.heatmap.may": "may", "analytics.heatmap.jun": "jun",
    "analytics.heatmap.jul": "jul", "analytics.heatmap.aug": "aug", "analytics.heatmap.sep": "sep",
    "analytics.heatmap.oct": "oct", "analytics.heatmap.nov": "nov", "analytics.heatmap.dec": "dec",
    "analytics.alerts.title": "Regulatory Compliance",
    "analytics.alerts.subtitle": "Active alerts on company inventory",
    "analytics.eer.title": "EER Codes",
    "analytics.eer.subtitle": "Hazardous vs non-hazardous waste",
    "analytics.eer.dangerous": "Hazardous {{count}}",
    "analytics.eer.notDangerous": "Non-hazardous {{count}}",
    "analytics.produttori.title": "Top Manufacturers",
    "analytics.produttori.subtitle": "Suppliers with most SDS in catalog",
    "analytics.alert.svch.label": "SVHC Substances",
    "analytics.alert.svch.desc": "ECHA notification required if > 0.1%",
    "analytics.alert.allegato_xiv.label": "Annex XIV REACH",
    "analytics.alert.allegato_xiv.desc": "Authorization of use with expiry date",
    "analytics.alert.env_hazard.label": "Environmental hazard",
    "analytics.alert.env_hazard.desc": "Special waste management required",
    "analytics.alert.cmr.label": "CMR Substances",
    "analytics.alert.cmr.desc": "Carcinogenic, mutagenic or reprotoxic (CLP Regulation)",
    "analytics.alert.alert_conc.label": "Concentration Alert",
    "analytics.alert.alert_conc.desc": "Regulatory concentration thresholds exceeded",
    "analytics.alert.seveso.label": "Seveso Threshold",
    "analytics.alert.seveso.desc": "Thresholds exceeded under Directive 2012/18/EU",
    "analytics.alert.old_sds.label": "SDS > 3 years",
    "analytics.alert.old_sds.desc": "Mandatory revision every 3 years under REACH",
    "analytics.export.button": "Export",
    "analytics.export.csv": "CSV",
    "analytics.export.excel": "Excel (.xlsx)",
    "analytics.export.pdf": "PDF",
    "analytics.loading": "Loading Analytics...",
    "analytics.error": "Error loading data",
    "analytics.noData": "No data available",

    // Table
    "table.emptyState": "No records available",
    "table.noResults": "No results match your filters",
    "table.noResultsHint": "Try changing or removing some filters.",
    "table.search": "Search",
    "table.filter": "Filter",
    "table.actions": "Actions",
    "table.selected": "Selection",
    "table.rowsPerPage": "Rows per page",
    "table.load-more": "Load more",
    "table.selectAll": "Select all",
    "table.deselectAll": "Deselect all",
    "table.selectedPageRecords": "You selected {{count}} records on this page.",
    "table.selectAllRecords": "Select all {{count}} records",
    "table.allRecordsSelected": "All {{count}} records are selected.",

    // Present only in it.js — without these the raw key rendered in English
    close: "Close",
    "parsed-table.expand-row": "Expand row",
    "parsed-table.collapse-row": "Collapse row",
    "parsed-table.lock-row": "Lock row",
    "parsed-table.unlock-row": "Unlock row",
    "parsed-table.lock-table": "Lock table",
    "parsed-table.unlock-table": "Unlock table",
    "table-columns-manager.title": "Manage columns",

    // Audit
    "audit.title": "Audit Log",
    "audit.sidebarLabel": "Audit",
    "audit.filterAll": "All",
    "audit.noRows": "No records in the log.",
    "audit.noRowsFiltered": "No records match your filters.",
    "audit.fetchError": "Could not load the audit log.",
    "audit.error401": "Session expired. Please log in again.",
    "audit.error403":
      "Access denied. Only admins and auditors can view the log.",
    "audit.error5xx": "Server error. Please try again later.",
    "audit.table.modifiche": "Changes (JSON)",
    "audit.table.changeField": "Field",
    "audit.table.changeBefore": "Before",
    "audit.table.changeAfter": "After",
    "audit.table.changeTimestamp": "Timestamp",
    "audit.table.changeUser": "User",
    "audit.table.changeIp": "IP",
    "audit.json.old_value": "Old value",
    "audit.json.new_value": "New value",

    "staff.consultants.title": "Consultants awaiting approval",
    "staff.consultants.subtitle": "Each approval automatically creates a personal workspace with the Demo plan.",
    "staff.consultants.pendingCount": "{{count}} pending",
    "staff.consultants.accessDenied": "Reserved for HSE Genius staff.",
    "staff.consultants.empty": "All clear — no pending requests.",
    "staff.consultants.table.name": "Name",
    "staff.consultants.table.email": "Email",
    "staff.consultants.table.phone": "Phone",
    "staff.consultants.table.vat": "VAT number",
    "staff.consultants.table.actions": "Actions",
    "staff.consultants.approve": "Approve",
    "staff.consultants.reject": "Reject",
    "staff.consultants.rejectDialog.title": "Reject {{name}}'s request",
    "staff.consultants.rejectDialog.text": "The consultant will receive an email with the reason for rejection. The account will be removed.",
    "staff.consultants.rejectDialog.reasonLabel": "Reason (optional)",
    "staff.consultants.rejectDialog.cancel": "Cancel",
    "staff.consultants.rejectDialog.confirm": "Confirm rejection",
    "staff.consultants.loadError": "Problem loading consultants.",
    "staff.consultants.approveSuccess": "{{name}} approved successfully.",
    "staff.consultants.approveError": "Approval failed. Please try again.",
    "staff.consultants.rejectSuccess": "{{name}}'s request removed.",
    "staff.consultants.rejectError": "Operation not completed. Please try again.",

    // Onboarding
    "onboarding.title": "Welcome to HSE Genius",
    "onboarding.subtitle":
      "To start using the platform, please register your company. You will receive 5 SDS credits to test the app.",
    "onboarding.creating": "Creating...",
    "onboarding.errors.generic": "Could not create company.",
    "onboarding.errors.unexpected": "Unexpected response. Please try again.",
    "onboarding.pending.title": "Your company is pending approval",
    "onboarding.pending.message":
      "Thanks for registering! Our team is reviewing your company. You'll receive an email as soon as it's approved, and then you'll be able to access the platform.",

    // Admin
    "admin.welcomeMessage":
      "Welcome! Please create your company to continue using the platform.",
    "admin.company.deleteSuccess": "User removed successfully.",
    "admin.company.roleUpdated": "Role updated successfully",
    "admin.company.resendInviteError": "Failed to resend invitation.",
    "admin.invites.resendError":
      "Failed to resend invitation. Please try again.",
    "admin.invites.removeError":
      "Failed to remove invitation. Please try again.",

    "sds-counter.analyzed": "safety data sheets already analysed",

    "auth.logout": "Sign out",
    "common.next": "Next",
    "common.errorGeneric": "An error occurred. Please try again.",
    "registration.complete": "Complete Registration",

    // Backend error toasts (see services/api/apiToastError.js)
    "api-error.generic":
      "An error occurred. If the problem persists, please contact support.",
    "api-error.invalid-credentials": "Incorrect email or password.",
    "api-error.session-expired": "Session expired. Please log in again.",
    "api-error.already-taken": "This value is already in use.",
    "api-error.already-exists": "This value already exists.",
    "api-error.field-required": "This field is required.",
    "api-error.field-blank": "This field cannot be empty.",
    "api-error.invalid-email": "Enter a valid email address.",
    "api-error.invalid-integer": "Enter a valid number.",
    "api-error.value-too-long": "The value entered is too long.",
    "api-error.value-too-short": "The value entered is too short.",
    "api-error.invalid-selection": "Invalid selection.",
    "api-error.invalid-number": "Invalid numeric value.",
    "api-error.permission-denied":
      "You do not have permission to perform this action.",
    "api-error.not-found": "Item not found.",
    "api-error.password-too-short":
      "The password is too short (minimum 8 characters).",
    "api-error.password-too-common":
      "The password is too common. Please choose a more secure one.",
    "api-error.password-numeric": "The password cannot be entirely numeric.",
    "api-error.password-mismatch": "The two password fields do not match.",
    "api-error.throttled": "Too many requests. Please try again shortly.",
    "api-error.credit-limit": "You have run out of available credits.",
    "api-error.request-limit": "You have reached the monthly request limit.",
    "api-error.file-size": "The file exceeds the maximum allowed size.",
    "api-error.file-type": "Unsupported file type.",
  },
};

export default en;
